<template>
  <a-modal :title="null" :centered="true" :mask-closable="false" :closable="false" :width="620" :visible="modal.visible"
           :footer="null" :body-style="{'padding':'12px', 'borderRadius':'4px'}">
    <div style="max-height: 800px; overflow-y: auto;">
      <div id="printDiv" style="width: 570px;">
        <template v-if="(modal.record.recipes||[]).length > 0">
          <template v-for="(item, index) in (modal.record.recipes||[])">
            <a-row :key="'d-'+(index+1)" style="margin-bottom: 20px;">
              <a-col span="24">
                <a-row style="margin-left: 8px;">
                  <a-col :sm="24" :xs="24" :md="24" :lg="24" :xl="24" :xxl="24"
                         style="text-align: center;font-size: 20px; font-weight: bold;margin-bottom: 10px;">
                    {{ modal.record.organ }}
                  </a-col>
                </a-row>
                <a-row style="margin-left: 8px;">
                  <a-col :sm="24" :xs="24" :md="24" :lg="24" :xl="24" :xxl="24"
                         style="text-align: center;font-size: 16px; font-weight: bold;margin-bottom: 10px;">门诊{{ item.type == 'CM' ? '中药处方' : item.type == 'CPM' ? '中成药处方' : item.type == 'WM' ? '西药处方' : item.type == 'SDP'?'专方':'处方' }}笺
                  </a-col>
                </a-row>
                <a-row class="row-flex" style="margin-left: 8px;line-height:32px;margin-bottom: 5px;">
                  <a-col :sm="24" :xs="5" :md="5" :lg="5" :xl="5" :xxl="5"><span class="medical-label">科别:</span><span
                          class="b-border">{{ modal.record.department || '-' }}</span></a-col>
                  <a-col :sm="24" :xs="5" :md="5" :lg="5" :xl="5" :xxl="5"><span class="medical-label">类别:</span><span class="b-border">自费</span>
                  </a-col>
                  <a-col :sm="24" :xs="8" :md="8" :lg="8" :xl="8" :xxl="8"><span class="medical-label">门诊号:</span><span
                          class="b-border">{{ modal.record.code || '-' }}</span></a-col>
                  <a-col :sm="24" :xs="6" :md="6" :lg="6" :xl="6" :xxl="6"><span
                          class="b-border">{{ modal.record.recipeTime || '-' }}</span></a-col>
                </a-row>
                <a-row style="margin-left: 8px;line-height:32px;">
                  <a-col :sm="24" :xs="24" :md="24" :lg="24" :xl="24" :xxl="24" class="t-border b-border l-border r-border"
                         style="padding-left: 3px;">
                    <a-row class="row-flex">
                      <a-col :sm="24" :xs="8" :md="8" :lg="8" :xl="8" :xxl="8"><span class="medical-label">姓名:</span><span
                              class="b-border">{{ modal.record.name || '-' }}</span></a-col>
                      <a-col :sm="24" :xs="8" :md="8" :lg="8" :xl="8" :xxl="8"><span class="medical-label">年龄:</span><span
                              class="b-border">{{ modal.record.age || '-' }}</span></a-col>
                      <a-col :sm="24" :xs="8" :md="8" :lg="8" :xl="8" :xxl="8"><span class="medical-label">性别:</span><span
                              class="b-border">{{ modal.record.sexName || '-' }}</span></a-col>
                    </a-row>
                  </a-col>
                </a-row>
                <a-row style="margin-left: 8px;line-height:32px;">
                  <a-col :sm="24" :xs="24" :md="24" :lg="24" :xl="24" :xxl="24" class="b-border l-border r-border"
                         style="padding-left: 3px;">
                    <a-row class="row-flex">
                      <a-col :sm="24" :xs="24" :md="24" :lg="24" :xl="24" :xxl="24"><span
                              class="medical-label">临床诊断:</span>{{ modal.record.diagnostic || '-' }}
                      </a-col>
                    </a-row>
                  </a-col>
                </a-row>
                <a-row style="margin-left: 8px;">
                  <a-col :sm="24" :xs="24" :md="24" :lg="24" :xl="24" :xxl="24" class="b-border l-border r-border"
                         style="padding-left: 3px;min-height: 500px;">
                    <a-row class="row-flex">
                      <a-col :sm="24" :xs="24" :md="24" :lg="24" :xl="24" :xxl="24">
                        <a-row class="row-flex">
                          <a-col :sm="24" :xs="24" :md="24" :lg="24" :xl="24" :xxl="24"
                                 style="margin-left: 10px; padding-top: 3px; padding-bottom: 3px;font-weight: bold;">Rp.
                          </a-col>
                        </a-row>
                        <a-row :key="'r-1-'+(index+1)" v-if="item.type == 'CM'">
                          <a-col v-for="(e, i) in item.drugs"
                                 style="padding-left: 20px;font-size:18px;white-space:pre-wrap;word-wrap:break-word;overflow:hidden;padding-top: 3px; padding-bottom: 3px;"
                                 :key="'d-'+(index+1)+(i+1)" :sm="24" :xs="12" :md="12" :lg="12" :xl="12" :xxl="12">
                            {{ e.name }}{{ e.spec }}&nbsp;&nbsp;{{ e.dosage }}{{ e.unit }}
                          </a-col>
                        </a-row>
                        <a-row v-else :key="'r-1-'+(index+1)">
                          <a-col v-for="(e, i) in item.drugs" style="padding-left: 20px;font-size:18px;white-space:nowrap;" :sm="24"
                                 :xs="24" :md="24" :lg="24" :xl="24" :xxl="24" :key="'d-'+(index+1)+(i+1)">
                            <div>{{ (i + 1) }}.&nbsp;{{ e.name }}&nbsp;&nbsp;{{ e.spec}}&nbsp;&nbsp;{{ e.salesQty }}{{ e.salesUnit }}</div>
                            <div style="margin-left: 5px;">
                              用法:&nbsp;&nbsp;&nbsp;{{ e.usage }}&nbsp;&nbsp;&nbsp;{{ e.dosage }}{{ e.unit }}&nbsp;&nbsp;&nbsp;{{ e.frequency }}
                            </div>
                          </a-col>
                        </a-row>
                        <a-row :key="'r-2-'+(index+1)">
                          <a-col style="text-align: left; line-height: 24px;padding-left: 40px;font-size:18px;margin-top: 12px;">
                            <span v-if="item.type == 'CM'">{{ item.doses }}付{{ (item.usage || '') != '' ? ',' : '' }}&nbsp;</span>
                            {{item.usageModelName||''}}&nbsp;{{ item.usage || '' }}
                          </a-col>
                        </a-row>
                      </a-col>
                    </a-row>
                  </a-col>
                </a-row>
                <a-row style="margin-left: 8px;">
                  <a-col :sm="24" :xs="24" :md="24" :lg="24" :xl="24" :xxl="24" class="b-border l-border r-border"
                         style="padding-left: 2px;">
                    <a-row class="row-flex" style="line-height:32px;">
                      <a-col :sm="24" :xs="8" :md="8" :lg="8" :xl="8" :xxl="8">
                        <span class="medical-label">医师:</span>
                        <span v-if="((modal.record.doctorSign||'') === '')" class="b-border">{{ (modal.record.expert || modal.record.doctor) }}{{ ((null!=modal.record.examine && modal.record.examine.examine && modal.record.examine.adopted) ? '/'+modal.record.examine.doctor : '') }}</span>
                        <img v-else :src="modal.record.doctorSign" style="width: 64px;height: 32px;">
                      </a-col>
                      <a-col :sm="24" :xs="8" :md="8" :lg="8" :xl="8" :xxl="8">
                        <span class="medical-label">审核:</span><span class="b-border">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                      </a-col>
                      <a-col :sm="24" :xs="8" :md="8" :lg="8" :xl="8" :xxl="8">
                        <span class="medical-label">金额:</span><span class="b-border" v-if="modal.amounted">&nbsp;{{ (item.amount||0.0).toFixed(2) }}&nbsp;&nbsp;</span><span class="b-border" v-else>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                      </a-col>
                    </a-row>
                    <a-row class="row-flex" style="line-height:32px;">
                      <a-col :sm="24" :xs="8" :md="8" :lg="8" :xl="8" :xxl="8">
                        <span class="medical-label">调配:</span>
                        <span v-if="((item.pharmacistSign||'') === '')" class="b-border">{{ (item.pharmacist || '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;') }}</span>
                        <img v-else :src="item.pharmacistSign" style="width: 64px;height: 32px;">
                      </a-col>
                      <a-col :sm="24" :xs="8" :md="8" :lg="8" :xl="8" :xxl="8">
                        <span class="medical-label">核对:</span><span class="b-border">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                      </a-col>
                      <a-col :sm="24" :xs="8" :md="8" :lg="8" :xl="8" :xxl="8">
                        <span class="medical-label">发药:</span>
                        <span v-if="((item.pharmacistSign||'') === '')" class="b-border">{{ (item.pharmacist || '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;') }}</span>
                        <img v-else :src="item.pharmacistSign" style="width: 64px;height: 32px;">
                      </a-col>
                    </a-row>
                  </a-col>
                </a-row>
              </a-col>
            </a-row>
          </template>
        </template>
        <template v-if="(modal.record.disposals||[]).length >0">
          <a-row style="page-break-after: always;">
            <a-col span="24">
              <a-row style="margin-left: 8px;">
                <a-col :sm="24" :xs="24" :md="24" :lg="24" :xl="24" :xxl="24"
                       style="text-align: center;font-size: 20px; font-weight: bold;margin-bottom: 10px;">
                  {{ modal.record.organ }}
                </a-col>
              </a-row>
              <a-row style="margin-left: 8px;">
                <a-col :sm="24" :xs="24" :md="24" :lg="24" :xl="24" :xxl="24"
                       style="text-align: center;font-size: 16px; font-weight: bold;margin-bottom: 10px;">门诊处置单
                </a-col>
              </a-row>
              <a-row class="row-flex" style="margin-left: 8px;line-height:32px;margin-bottom: 5px;">
                <a-col :sm="24" :xs="5" :md="5" :lg="5" :xl="5" :xxl="5"><span>科别:</span><span
                        class="b-border">{{ modal.record.department || '-' }}</span></a-col>
                <a-col :sm="24" :xs="5" :md="5" :lg="5" :xl="5" :xxl="5"><span>类别:</span><span class="b-border">自费</span>
                </a-col>
                <a-col :sm="24" :xs="8" :md="8" :lg="8" :xl="8" :xxl="8"><span>门诊号:</span><span
                        class="b-border">{{ modal.record.code || '-' }}</span></a-col>
                <a-col :sm="24" :xs="6" :md="6" :lg="6" :xl="6" :xxl="6"><span
                        class="b-border">{{ modal.record.recipeTime || '-' }}</span></a-col>
              </a-row>
              <a-row style="margin-left: 8px;line-height:32px;">
                <a-col :sm="24" :xs="24" :md="24" :lg="24" :xl="24" :xxl="24" class="t-border b-border l-border r-border"
                       style="padding-left: 3px;">
                  <a-row class="row-flex">
                    <a-col :sm="24" :xs="8" :md="8" :lg="8" :xl="8" :xxl="8"><span class="medical-label">姓名:</span><span
                            class="b-border">{{ modal.record.name || '-' }}</span></a-col>
                    <a-col :sm="24" :xs="8" :md="8" :lg="8" :xl="8" :xxl="8"><span class="medical-label">年龄:</span><span
                            class="b-border">{{ modal.record.age || '-' }}</span></a-col>
                    <a-col :sm="24" :xs="8" :md="8" :lg="8" :xl="8" :xxl="8"><span class="medical-label">性别:</span><span
                            class="b-border">{{ modal.record.sexName || '-' }}</span></a-col>
                  </a-row>
                </a-col>
              </a-row>
              <a-row style="margin-left: 8px;line-height:32px;">
                <a-col :sm="24" :xs="24" :md="24" :lg="24" :xl="24" :xxl="24" class="b-border l-border r-border"
                       style="padding-left: 3px;">
                  <a-row class="row-flex">
                    <a-col :sm="24" :xs="24" :md="24" :lg="24" :xl="24" :xxl="24"><span
                            class="medical-label">临床诊断:</span>{{ modal.record.diagnostic || '-' }}
                    </a-col>
                  </a-row>
                </a-col>
              </a-row>
              <a-row style="margin-left: 8px;">
                <a-col :sm="24" :xs="24" :md="24" :lg="24" :xl="24" :xxl="24" class="b-border l-border r-border"
                       style="padding-left: 3px;height: 500px;">
                  <a-row class="row-flex">
                    <a-col :sm="24" :xs="24" :md="24" :lg="24" :xl="24" :xxl="24">
                      <a-row class="row-flex">
                        <a-col :sm="24" :xs="24" :md="24" :lg="24" :xl="24" :xxl="24"
                               style="margin-left: 10px; padding-top: 3px; padding-bottom: 3px;font-weight: bold;">Rp.
                        </a-col>
                      </a-row>
                      <a-row>
                        <a-col v-for="(e, i) in (modal.record.disposals||[])"
                               style="padding-left: 20px;white-space:pre-wrap;word-wrap:break-word;overflow:hidden;padding-top: 3px; padding-bottom: 3px;"
                               :key="'p-'+(i+1)" :sm="24" :xs="12" :md="12" :lg="12" :xl="12" :xxl="12">
                          {{ e.disposeName }}&nbsp;{{ e.quantity }}{{ e.unit }}<span v-if="(e.describe||'') != ''" style="margin-left: 5px;">,({{ e.describe }})</span>
                        </a-col>
                      </a-row>
                    </a-col>
                  </a-row>
                </a-col>
              </a-row>
              <a-row style="margin-left: 8px;">
                <a-col :sm="24" :xs="24" :md="24" :lg="24" :xl="24" :xxl="24" class="b-border l-border r-border"
                       style="padding-left: 2px;">
                  <a-row class="row-flex" style="line-height:32px;">
                    <a-col :sm="24" :xs="8" :md="8" :lg="8" :xl="8" :xxl="8">
                      <span class="medical-label">医师:</span>
                      <span v-if="((modal.record.doctorSign||'') === '')" class="b-border">{{ (modal.record.expert || modal.record.doctor) }}</span>
                      <img v-else :src="modal.record.doctorSign" style="width: 64px;height: 32px;">
                    </a-col>
                    <a-col :sm="24" :xs="8" :md="8" :lg="8" :xl="8" :xxl="8">
                      <span class="medical-label">审核:</span><span class="b-border">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    </a-col>
                    <a-col :sm="24" :xs="8" :md="8" :lg="8" :xl="8" :xxl="8">
                      <span class="medical-label">金额:</span><span class="b-border" v-if="modal.amounted === true">&nbsp;{{ (modal.record.disposeAmount||0.0).toFixed(2) }}&nbsp;&nbsp;</span><span class="b-border" v-else>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    </a-col>
                  </a-row>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
        </template>
      </div>
    </div>
    <div style="text-align: center;margin-top: 12px; height: 32px;">
      <img src="../../assets/img/print.png" style="cursor: pointer;user-select: none;margin-right: 12px;" v-print="'#printDiv'"/>
      <img src="../../assets/img/close.png" style="cursor: pointer;user-select: none;" @click="()=>onModalClose()"/>
    </div>
  </a-modal>
</template>

<script>
import Vue from 'vue';
import Print from 'vue-print-nb'

Vue.use(Print);  //注册
export default {
  name: "DefaultRecipeZaqo",
  data() {
    return {
      modal: {
        current: {},
        visible: false,
        amounted:false,
        record: {}
      }
    }
  },
  mounted() {
    this.current = JSON.parse(localStorage.getItem("curruser"));
  },
  methods: {
    showZaqoAction: function (id) {
      const self = this;
      this.getOrganConfig(this.current.organId,'108',function (res) {
        if((res||'0') === '1'){
          self.modal.amounted = true;
        }else{
          self.modal.amounted = false;
        }
      });
      this.$axios.get('/api/clinic/outpatient/' + id + '/medical').then(function (res) {
        if (res.msg.flag == 0) {
          if (undefined != res.biz && null != res.biz) {
            self.modal.record = res.biz;
            self.modal.visible = true;
          }
        } else {
          self.$message.error({content: res.msg.message, duration: 2});
        }
      }, function (res) {
      });
    },
    onModalClose: function () {
      this.$emit('clickit');
      this.modal.record = {};
      this.modal.visible = false;
    },
  }
}
</script>

<style scoped>
.t-border {
  border-top: #333333 solid 2px;
  min-height: 28px;
  font-weight: bold;
}

.l-border {
  border-left: #333333 solid 2px;
  min-height: 28px;
  align-items: center;
  font-weight: bold;
}

.b-border {
  border-bottom: #333333 solid 2px;
  min-height: 28px;
  font-weight: bold;
}

.r-border {
  border-right: #333333 solid 2px;
  min-height: 28px;
  font-weight: bold;
}

.medical-label {
  min-height: 28px;
  text-align: center;
  font-weight: bold;
}

.row-flex {
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
</style>
